import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export const AdminLogin = () => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-lg shadow-[0_8px_24px_rgba(15,23,42,0.3)] p-8 sm:p-10">
          <div className="flex justify-center mb-6">
            <img src="/assets/prgl-logo.png" alt="PRGL" className="h-10 w-auto" />
          </div>
          <div className="flex items-center gap-2 justify-center text-slate-500 text-sm mb-8">
            <Lock size={14} /> Admin area — authorised staff only
          </div>
          <form onSubmit={submit} className="space-y-5" data-testid="admin-login-form">
            <div className="space-y-2">
              <Label htmlFor="admin-email">Email</Label>
              <Input id="admin-email" type="email" data-testid="admin-login-email" value={email}
                onChange={(e) => setEmail(e.target.value)} placeholder="admin@prgl.co.uk" autoComplete="email" />
            </div>
            <div className="space-y-2">
              <Label htmlFor="admin-password">Password</Label>
              <Input id="admin-password" type="password" data-testid="admin-login-password" value={password}
                onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="admin-login-error">{error}</p>}
            <Button type="submit" disabled={loading} data-testid="admin-login-submit"
              className="w-full h-11 bg-blue-600 hover:bg-blue-700 text-white rounded-md">
              {loading ? <Loader2 className="animate-spin mr-2 h-4 w-4" /> : null}
              {loading ? "Signing in..." : "Sign in"}
            </Button>
          </form>
          <Link to="/" className="block text-center text-sm text-slate-500 hover:text-blue-700 transition-colors mt-6" data-testid="admin-back-to-site">
            ← Back to website
          </Link>
        </div>
      </div>
    </div>
  );
};
